export const VENDORURLS = {
  // 一个基于rsa加解密的js库
  jsencrypt: 'https://s3.e.vhall.com/common-static/middle/jsencrypt/3.2.1/dist/jsencrypt.min.js'
}